import {
	get,
	post
} from './http'

export default {
	getDriverData(openid) {
		return get('Driver/getDriverData', {
			openid: openid
		});
	},
	saveDriverInfo(openid, realname, idcard, carno, mobile, district, address, companyaddress, headpic, sex = '男',
		province = '广东省', city = '中山市') {
		return post('Driver/saveDriverInfo', {
			openid: openid,
			realname: realname,
			idcard: idcard,
			carno: carno,
			mobile: mobile,
			district: district,
			address: address,
			companyaddress: companyaddress,
			headpic: headpic,
			sex: sex,
			province: province,
			city: city
		});
	},
	getJobDateList(openid) {
		return get('Driver/getJobDateList', {
			openid: openid
		});
	},
	getJobList(openid, jobdate) {
		return get('Driver/getJobList', {
			openid: openid,
			jobdate: jobdate
		});
	},
	makeAppointServiceLog(OpenId, LogType, OrderNum, Location = '') {
		return post('Manager/PickupPlans/MakeAppointServiceLog', {
			openid: OpenId,
			logtype: LogType,
			ordernum: OrderNum,
			location: Location
		});
	},
	getAppointServiceLogList(OrderNum) {
		return get('Manager/PickupPlans/getAppointServiceLogList', {
			ordernum: OrderNum
		});
	},
	getDriverStat(OpenId, StartDate, EndDate) {
		return get('Driver/getDriverStat', {
			openid: OpenId,
			startdate: StartDate,
			enddate: EndDate
		});
	}
}



// WEBPACK FOOTER //
// ./src/request/driverApi.js